import type { UseFetchOptions } from 'nuxt/app'
import { useLogger } from './useLogger'
import { useApiService } from './useApiService'

export interface SessionResponse {
  url: string;
  token: string;
}

export interface SessionConfig {
  model: string;
  voice: string;
  modalities: string[];
  tool_choice: string;
  instructions: string;
  user_id: string;
}

export function useOpenAIService() {
    const logger = useLogger()
    const { makeApiCall } = useApiService()

    const createSession = async (config: SessionConfig, options?: UseFetchOptions<SessionResponse>) => {
        logger.debug('OpenAIService: Creating new session with config:', config)
        
        try {
            const response = await makeApiCall<SessionConfig, SessionResponse>(
                'openai-session',
                config,
                'OpenAIService',
                options
            )
            
            logger.info('OpenAIService: Session created successfully')
            return response
        } catch (error: any) {
            logger.error('OpenAIService: Failed to create session:', error)
            
            if (error.statusCode === 400) {
                throw new Error('Please set your OpenAI API key in the .env file')
            }
            
            throw new Error(`Failed to create OpenAI session: ${error.message || 'Unknown error'}`)
        }
    }

    return {
        createSession
    }
} 